import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import { stylesheet } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/DeliveryTypeCategorySelector/styles'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { LayoutChangeEvent, Pressable } from 'react-native'
import { useStyles } from 'react-native-unistyles'

interface DeliveryTypeCategoryOptionProps {
    category: DeliveryTypeCategory
    isActive: boolean
    disabled: boolean
    label: string
    onLayout: (event: LayoutChangeEvent) => void
    onPress: (category: DeliveryTypeCategory) => void
}

const DeliveryTypeCategoryOption: FC<DeliveryTypeCategoryOptionProps> = ({
    category,
    isActive,
    disabled,
    label,
    onLayout,
    onPress,
}) => {
    const { styles } = useStyles(stylesheet)

    return (
        <Pressable
            disabled={disabled}
            onPress={() => onPress(category)}
            style={styles.option}
            onLayout={onLayout}
        >
            <Typography.Menu size="small" style={[styles.label, isActive && styles.labelActive]}>
                {label}
            </Typography.Menu>
        </Pressable>
    )
}

export default DeliveryTypeCategoryOption
